export default "__VITE_ASSET__BbZknm3y__"